import { ChevronRightRounded } from "@mui/icons-material";
import { Switch } from "@mui/material";
import styles from "./css/ListSettingView.module.css";
import Divider from "./Divider";

interface ListSettingViewProps {
  title: string;
  description?: string;
  leftIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  leftIconColor?: string;
  value?: string;
  booleanValue?: boolean;
  valueStyle: "booleanValue" | "stringValue";
  showingDivider?: boolean;
  handleOnClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  handleOnBooleanValueChange?: (isOn: boolean) => void;
}

export default function ListSettingView(props: ListSettingViewProps) {
  const LeftIcon = props.leftIcon;

  function handleOnClickValueContainer(e: React.MouseEvent<HTMLDivElement>) {
    e.stopPropagation();
    if (props.handleOnClick !== undefined) {
      props.handleOnClick(e);
    }
  }

  return (
    <>
      <div className={styles.main}>
        <div
          className={styles.container}
          onClick={props.handleOnClick}
          role={props.handleOnClick !== undefined ? "button" : undefined}
          tabIndex={props.handleOnClick !== undefined ? 0 : undefined}
          onKeyDown={(e) => {
            if (
              props.handleOnClick !== undefined &&
              (e.key === "Enter" || e.key === " ")
            ) {
              e.preventDefault();
              props.handleOnClick(
                e as unknown as React.MouseEvent<HTMLDivElement>
              );
            }
          }}
        >
          <div className={styles.leftContainer}>
            {LeftIcon !== undefined && (
              <div className={styles.leftImageContainer}>
                <LeftIcon
                  className={styles.icon}
                  style={{
                    width: "24px",
                    height: "24px",
                    color: props.leftIconColor,
                  }}
                />
              </div>
            )}
            <div className={styles.titleContainer}>
              <span className={styles.titleText}>{props.title}</span>
              {props.description !== undefined && (
                <span className={styles.descriptionText}>
                  {props.description}
                </span>
              )}
            </div>
          </div>
          {props.valueStyle === "stringValue" && (
            <div
              className={styles.valueContainer}
              onClick={handleOnClickValueContainer}
            >
              <span className={styles.valueText}>{props.value}</span>
              <ChevronRightRounded className={styles.dropDownImage} />
            </div>
          )}
          {props.valueStyle === "booleanValue" && (
            <Switch
              checked={props.booleanValue ?? false}
              onChange={(_, checked) => {
                if (props.handleOnBooleanValueChange !== undefined) {
                  props.handleOnBooleanValueChange(checked);
                }
              }}
            />
          )}
        </div>
        {props.showingDivider !== undefined && props.showingDivider && (
          <Divider />
        )}
      </div>
    </>
  );
}
